module.exports = (__webpack_require__(4233))(72);


//////////////////
// WEBPACK FOOTER
// delegated ./src/entries/index.js from dll-reference dibs_buyer_layout
// module id = 2310
// module chunks = 62